module.exports = __webpack_public_path__ + "static/media/  (17).61d5cd25.jpg";